import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, Col, Form, FormFeedback, FormGroup, FormText, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import Icon from '../../../components/Icon';
import AppModal from '../../../components/Modal';
import { addOrganization } from '../../../actions/api';
import * as types from '../../../constants/ActionTypes';
const NAME_MIN_LENGTH = 3;
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export const withNewOrganizationModal = (WrappedComponent) => connect(void 0, mapDispatchToProps)(withTranslation()(class NewOrganizationModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            processing: false,
            callback: (id, name) => void 0,
            name: '',
            nameExists: false,
        };
        this.handleCloseModal = () => {
            this.setState({ open: false });
        };
        this.handleClick = (callback) => {
            this.setState({
                open: true,
                processing: false,
                callback: callback || ((id, name) => void 0),
                nameExists: false,
            });
        };
        this.handleSubmit = (event) => {
            if (event) {
                event.preventDefault();
            }
            this.setState({
                processing: true,
            });
            this.props.dispatch(addOrganization({ name: this.state.name })).then((action) => {
                if (action.type === types.ADD_ORGANIZATION_SUCCESS) {
                    this.setState({
                        open: false,
                        processing: false,
                    });
                    this.state.callback(action.response.data.id, this.state.name);
                }
                else if (action.error.response.status === 409 &&
                    action.error.response.data.error === 'Name already exists') {
                    this.setState({
                        processing: false,
                        nameExists: true,
                    });
                }
            });
        };
        this.handleChange = (property, event) => {
            const value = event.target.value;
            // @ts-expect-error TS2345: Argument of type is not assignable
            this.setState((prevState) => {
                return {
                    [property]: value,
                    nameExists: property === 'name' ? false : prevState.nameExists,
                };
            });
        };
    }
    renderModal() {
        const { t } = this.props;
        return (_jsxs(Modal, { isOpen: true, toggle: this.handleCloseModal, autoFocus: false, children: [_jsx(ModalHeader, { toggle: this.handleCloseModal, children: t('organizations.createOrganization') }), _jsx(ModalBody, { children: _jsx(Form, { onSubmit: this.handleSubmit, children: _jsxs(FormGroup, { row: true, children: [_jsx(Label, { for: "name", sm: 2, children: t('organizations.name') }), _jsxs(Col, { sm: 10, children: [_jsx(Input, { type: "text", name: "name", id: "name", value: this.state.name, onChange: (event) => this.handleChange('name', event), placeholder: t('organizations.namePlaceholder'), invalid: this.state.nameExists, autoFocus: true }), !this.state.nameExists ? null : (_jsx(FormFeedback, { children: t('organizations.nameExists') })), this.state.name.length >= NAME_MIN_LENGTH ? null : (_jsx(FormText, { children: t('organizations.minLengthConstraint', {
                                                count: NAME_MIN_LENGTH,
                                            }) }))] })] }) }) }), _jsxs(ModalFooter, { children: [_jsxs(Button, { color: "primary", onClick: this.handleSubmit, disabled: this.state.processing || this.state.name.length < NAME_MIN_LENGTH, children: [!this.state.processing ? null : (_jsx(Icon, { name: "spinner", pulse: true, fixedWidth: true, className: "mr-2" })), t('organizations.create')] }), _jsx(Button, { color: "light", onClick: this.handleCloseModal, children: t('cancel') })] })] }));
    }
    render() {
        return (_jsxs("div", { children: [_jsx(WrappedComponent, { ...this.props, onNewOrganizationClick: this.handleClick }), !this.state.open ? null : _jsx(AppModal, { children: this.renderModal() })] }));
    }
}));
